const animateItems = document.querySelectorAll('.reveal');

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('fade-in-bottom'); // Add the animate class when item is in viewport
      observer.unobserve(entry.target); // Unobserve the item to avoid repeated animations
    }
  });
});

animateItems.forEach(item => {
  observer.observe(item);
});